import React from "react";
import { PageContext } from "../context/page-context";

const countries = {
  NZ: "New Zealand",
  AU: "Australia",
  GB: "United Kingdom",
  US: "United States",
  ROW: "Rest of World",
};

class HardwareCountrySelector extends React.Component {
  constructor(props) {
    super(props);
    this.changeCountry = this.changeCountry.bind(this);
  }

  changeCountry(e) {
    // const { setLocation, setPageContext } = this.context;
    const { setLocation } = this.context;

    const value = e.target.value;
    setLocation(value, this.context);
    // setPageContext('geolocation', value);
  }

  render() {
    const { geolocation } = this.context;

    const {
      content: { label },
    } = this.props.block;

    let location = "ROW";
    if (Object.keys(countries).includes(geolocation)) {
      location = geolocation;
    }

    return (
      <div className='HardwareCountrySelector'>
        <strong className='HardwareCountrySelector-label'>{label}</strong>
        <div className='crane-field'>
          <div className='mdc-select mdc-select--outlined'>
            <i className='mdc-select__dropdown-icon Pricing-chevron fa fa-angle-up fa-angle-down'></i>
            <select
              id='select-hardware-input'
              className='mdc-select__native-control'
              onChange={this.changeCountry}
              name='country'
              value={location}
            >
              {Object.keys(countries).map((value) => (
                <option key={value} value={value}>
                  {countries[value]}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }
}
HardwareCountrySelector.contextType = PageContext;

export default HardwareCountrySelector;
